module.exports = "//imgak.mmtcdn.com/rails_cdn_dt/static/media/genericerror.dba793a6.png";